import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FormWrapper = styled.div``;

export const FormSection = styled.div``;

export const InputLabel = styled(typography.BodyTextOneBoldTypography)`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.black};
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const InputStyle = css`
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme, error }) => (error ? theme.colors.redMain : theme.colors.grey003)};
  border-radius: 4px;
  box-sizing: border-box;

  &::placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const PointsIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background: linear-gradient(
    ${({ theme }) =>
      `180deg,
      ${theme.colors.yellowMain} 2.61%,
      ${theme.colors.yellowDark} 100%
    `}
  );
  border-radius: 50%;
  &::after {
    content: ${'"\\e912"'};
    position: absolute;
    font-family: 'icomoon' !important;
    font-size: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.colors.orangeDark};
  }
`;

export const PointsInput = styled.input`
  ${InputStyle}
  padding: 8px 12px 8px 32px;
`;

export const PhoneNumberInput = styled.input`
  ${InputStyle}
`;

export const SelectInput = styled.select`
  ${InputStyle}
`;

export const ReasonInput = styled.textarea`
  ${InputStyle}
  height: 76px;
  resize: none;
`;

export const ValidationErrMsg = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const Button = styled.button`
  cursor: pointer;
  padding: 10px 0;
  width: 100%;
  border-radius: 4px;
  background-color: ${({ theme, toAddPoints }) =>
    toAddPoints ? theme.colors.blueMain : theme.colors.redMain};
  border: none;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
`;
